import {inject, Injectable} from "@angular/core";
import {MomentDateAdapter} from "@angular/material-moment-adapter";
import {TranslateService} from "@ngx-translate/core";
import moment from "moment";

export const CALENDER_WEEK_KEY = {
    translationKey: "menu-planning.calender-week-short"
}

@Injectable()
export class TranslateMomentAdapter extends MomentDateAdapter {
    private readonly translateService = inject(TranslateService);

    public override format(date: moment.Moment, displayFormat: string): string {
        const formatted = super.format(date, displayFormat);
        return formatted.replace('KW', this.translateService.instant(CALENDER_WEEK_KEY.translationKey));
    }

    public override parse(value: unknown, parseFormat: string | string[]): moment.Moment | null {
        if (typeof value === 'string' && value.trim()) {
            const normalizedValue = value.replace(this.translateService.instant(CALENDER_WEEK_KEY.translationKey), 'KW');
            return super.parse(normalizedValue, parseFormat);
        }
        return super.parse(value, parseFormat);
    }
}